import { render, staticRenderFns } from "./recharge_agreement.vue?vue&type=template&id=5d1fe046&scoped=true&"
import script from "./recharge_agreement.vue?vue&type=script&lang=js&"
export * from "./recharge_agreement.vue?vue&type=script&lang=js&"
import style0 from "./recharge_agreement.vue?vue&type=style&index=0&id=5d1fe046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fe046",
  null
  
)

export default component.exports